import { createContext } from 'react';
import { AuthContextType } from '../types/auth-context.type';
import { FetchResult } from '@apollo/client';
import { LoginResultType } from '../types/qraphql/login-result.type';

export const AuthContext = createContext<AuthContextType>({
    isAuthenticated: false,
    setIsAuthenticated: (): void => {
        return;
    },
    isLoading: false,
    user: undefined,
    setUser: (): void => {
        return;
    },
    logout: (): Promise<FetchResult<boolean>> => {
        return new Promise<FetchResult<boolean>>(function (resolve) {
            resolve({});
        });
    },
    login: (): Promise<FetchResult<LoginResultType>> => {
        return new Promise<FetchResult<LoginResultType>>(function (resolve) {
            resolve({});
        });
    },
});
